"use strict";
exports.__esModule = true;
//@ts-nocheck
var o;
function pageit(opt) {
    try {
        o = opt;
        this._init();
    }
    catch (error) {
        console && console.info(error);
    }
}
pageit.prototype._init = function () {
    var p = isNaN(o.page) ? 1 : parseInt(o.page);
    var pages = isNaN(o.pages) ? 1 : parseInt(o.pages);
    var pagenav = o.pagenav || "PageCont";
    var miniPageNav = o.miniPageNav || "miniPageNav";
    var go = o.go || function (p) {
        console && console.info(p);
    };
    var _pn = document.getElementById(pagenav);
    var _minipn = document.getElementById(miniPageNav);
    if (_minipn) {
        var mini_bs = _minipn.getElementsByTagName("b");
        if (mini_bs.length == 4) {
            mini_bs[3].innerHTML = "共<span class=\"red\">" + pages + "</span>页";
            mini_bs[1].innerHTML = "上一页";
            mini_bs[2].innerHTML = "下一页";
            if (p <= 1) {
                mini_bs[1].className = "n1";
                mini_bs[1].onclick = null;
                mini_bs[1].setAttribute("title", "");
            }
            else {
                mini_bs[1].className = "n2";
                mini_bs[1].setAttribute("title", "转到第" + (p - 1) + "页");
                mini_bs[1].onclick = function (n) {
                    go(p - 1);
                };
            }
            if (p >= pages) {
                mini_bs[2].className = "n1";
                mini_bs[2].setAttribute("title", "");
                mini_bs[2].onclick = null;
            }
            else {
                mini_bs[2].className = "n2";
                mini_bs[2].setAttribute("title", "转到第" + (p + 1) + "页");
                mini_bs[2].onclick = function (n) {
                    go(p + 1);
                };
            }
            mini_bs[0].innerHTML = "当前第<span class=\"red\">" + p + "</span>页";
        }
        else if (mini_bs.length == 6) {
            mini_bs[5].innerHTML = "共<span class=\"red\">" + pages + "</span>页";
            mini_bs[1].innerHTML = "首页";
            mini_bs[2].innerHTML = "上一页";
            mini_bs[3].innerHTML = "下一页";
            mini_bs[4].innerHTML = "尾页";
            if (p <= 1) {
                mini_bs[2].className = mini_bs[1].className = "n1";
                mini_bs[2].onclick = mini_bs[1].onclick = null;
                mini_bs[2].setAttribute("title", "");
                mini_bs[1].setAttribute("title", "");
            }
            else {
                mini_bs[2].className = mini_bs[1].className = "n2";
                mini_bs[2].setAttribute("title", "转到第" + (p - 1) + "页");
                mini_bs[1].setAttribute("title", "转到首页");
                mini_bs[2].onclick = function (n) {
                    go(p - 1);
                };
                mini_bs[1].onclick = function (n) {
                    go(1);
                };
            }
            if (p >= pages) {
                mini_bs[3].className = mini_bs[4].className = "n1";
                mini_bs[3].setAttribute("title", "");
                mini_bs[4].setAttribute("title", "");
                mini_bs[3].onclick = mini_bs[4].onclick = null;
            }
            else {
                mini_bs[3].className = mini_bs[4].className = "n2";
                mini_bs[3].setAttribute("title", "转到第" + (p + 1) + "页");
                mini_bs[4].setAttribute("title", "转到尾页");
                mini_bs[3].onclick = function (n) {
                    go(p + 1);
                };
                mini_bs[4].onclick = function (n) {
                    go(pages);
                };
            }
            mini_bs[0].innerHTML = "当前第<span class=\"red\">" + p + "</span>页";
        }
    }
    if (!_pn)
        return;
    _pn.innerHTML = "";
    if (pages == 0 || (p == pages && pages == 1)) {
        _pn.parentNode.style.display = "none";
        _minipn.style.display = "none";
        return;
    }
    else {
        _pn.parentNode.style.display = "";
        _minipn.style.display = "block";
    }
    var _a = document.createElement("a");
    _pn.appendChild(_a);
    _a.setAttribute("href", "javascript:void(0);");
    _a.setAttribute("target", "_self");
    _a.innerHTML = "上一页";
    if (p == 1) {
        _a.className = "nolink";
        _a.onclick = function () {
            return false;
        };
    }
    else {
        _a.className = "";
        _a.setAttribute("href", "javascript:void(0);");
        _a.setAttribute("target", "_self");
        _a.setAttribute("title", "转到第" + (p - 1) + "页");
        _a.onclick = function () {
            go(p - 1);
        };
    }
    var start = (p > 3) ? p - 2 : 1;
    start = (p > pages - 3 && pages > 4) ? pages - 4 : start;
    var end = (start == 1) ? 5 : start + 4;
    end = (end > pages) ? pages : end;
    if (start > 1) {
        var pre = ((start - 3) < 1) ? 1 : (start - 3);
        var _pre = ((start - 3) > pages) ? pages : (next + 3);
        _a = document.createElement("a");
        _pn.appendChild(_a);
        _a.setAttribute("href", "javascript:void(0);");
        _a.setAttribute("target", "_self");
        _a.setAttribute("title", "转到第一页");
        _a.onclick = function () {
            go(1);
        };
        _a.innerHTML = 1;
        if (pre > 1) {
            _a = document.createElement("a");
            _pn.appendChild(_a);
            _a.setAttribute("href", "javascript:void(0);");
            _a.setAttribute("target", "_self");
            _a.setAttribute("title", "转到上一组");
            _a.onclick = function () {
                go(pre);
            };
            _a.className = "next";
            _a.innerHTML = "...";
        }
    }
    for (var i = start; i <= end; i++) {
        if (p == i) {
            _a = document.createElement("span");
            _pn.appendChild(_a);
            _a.className = "at";
            _a.innerHTML = i;
        }
        else {
            _a = document.createElement("a");
            _pn.appendChild(_a);
            _a.setAttribute("href", "javascript:void(0);");
            _a.setAttribute("target", "_self");
            _a.setAttribute("title", "转到第" + i + "页");
            _a.setAttribute("data-p", i);
            $(_a).off("click").on("click", function () {
                go($(this).data("p"));
            });
            _a.innerHTML = i;
        }
    }
    if (pages > end) {
        var next = ((end + 3) > pages) ? pages : (end + 3);
        var _nex = ((next + 3) > pages) ? pages : (next + 3);
        _a = document.createElement("a");
        _pn.appendChild(_a);
        _a.setAttribute("href", "javascript:void(0);");
        _a.setAttribute("target", "_self");
        _a.setAttribute("title", "转到下一组");
        _a.onclick = function () {
            go(next);
        };
        _a.className = "next";
        _a.innerHTML = "...";
        if (next < pages) {
            _a = document.createElement("a");
            _pn.appendChild(_a);
            _a.setAttribute("href", "javascript:void(0);");
            _a.setAttribute("target", "_self");
            _a.setAttribute("title", "转到最后一页");
            _a.onclick = function () {
                go(pages);
            };
            _a.innerHTML = pages;
        }
    }
    _a = document.createElement("a");
    _pn.appendChild(_a);
    _a.setAttribute("href", "javascript:void(0);");
    _a.setAttribute("target", "_self");
    if (p == pages) {
        _a.className = "nolink";
        _a.innerHTML = "下一页";
        _a.onclick = function () {
            return false;
        };
    }
    else {
        _a.innerHTML = "下一页";
        _a.onclick = function () {
            go(p + 1);
        };
        _a.setAttribute("title", "转到" + (p + 1) + "页");
    }
    _a = document.createElement("span");
    _pn.appendChild(_a);
    _a.className = "txt";
    _a.innerHTML = "&nbsp;&nbsp;转到";
    _a = document.createElement("input");
    _pn.appendChild(_a);
    _a.className = "txt";
    _a.id = pagenav + "gopage";
    _a.value = p;
    _a = document.createElement("a");
    _pn.appendChild(_a);
    _a.className = "btn_link";
    _a.onclick = function () {
        if (document.getElementById(pagenav + "gopage")) {
            var p = document.getElementById(pagenav + "gopage").value;
            if (isNaN(p) || parseInt(p) < 0) {
                p = 1;
            }
            go(p);
        }
    };
    _a.innerHTML = "Go";
};
pageit.prototype.set = function (opt) {
    try {
        $.extend(o, opt);
        this._init();
    }
    catch (error) {
        console && console.info(error);
    }
};
exports["default"] = pageit;
